// packages/i18n/src/default-i18n.ts
import { defaultHooks } from "@wordpress/hooks";
import { createI18n } from "./create-i18n.mjs";
var i18n = createI18n(void 0, void 0, defaultHooks);
var default_i18n_default = i18n;
var getLocaleData = i18n.getLocaleData.bind(i18n);
var setLocaleData = i18n.setLocaleData.bind(i18n);
var resetLocaleData = i18n.resetLocaleData.bind(i18n);
var subscribe = i18n.subscribe.bind(i18n);
var __ = i18n.__.bind(i18n);
var _x = i18n._x.bind(i18n);
var _n = i18n._n.bind(i18n);
var _nx = i18n._nx.bind(i18n);
var isRTL = i18n.isRTL.bind(i18n);
var hasTranslation = i18n.hasTranslation.bind(i18n);
export {
  __,
  _n,
  _nx,
  _x,
  default_i18n_default as default,
  getLocaleData,
  hasTranslation,
  isRTL,
  resetLocaleData,
  setLocaleData,
  subscribe
};
//# sourceMappingURL=default-i18n.mjs.map
